import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SkillAccessDeniedBlock({
  block
}) {
  const {
    skillName
  } = block;
  // Scope IDs are internal identifiers, so the copy stays generic and points
  // the user to their admin rather than surfacing the raw required scopes.
  return /*#__PURE__*/_jsxs(Flex, {
    "data-block-type": "skill-access-denied",
    alignItems: "center",
    gap: "200",
    paddingBlock: "200",
    paddingInline: "300",
    borderRadius: "200",
    borderWidth: "100",
    borderStyle: "dashed",
    borderColor: "border-core-default",
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(LockedIcon, {
      size: "300"
    }), /*#__PURE__*/_jsx(Text, {
      use: "help",
      color: "text-core-subtle",
      children: skillName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breezeEngineChatComponents.blocks.skillAccessDenied",
        options: {
          skillName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breezeEngineChatComponents.blocks.skillAccessDeniedUnnamed"
      })
    })]
  });
}